module.exports = __webpack_public_path__ + "media/images/icon-dynamic-pricing-light-f7962448861f9fd8c35635efc5abc5b3.svg";